import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@decisiv/ui-components';
import { t } from '@lingui/macro';
import {
  ContinuedSectionRow,
  LabelOnlyRow,
  SectionRow,
} from './StyledComponents';
import CommandIconAndTitle from '../../components/CommandIconAndTitle';
import ClassificationInputs from './ClassificationInputs';

const LOCATION_SETTINGS_TAG = 'location_settings_input';

const GroupedStaticAttributesSection = ({
  groupedStaticAttributes,
  handleSchemaDetailsModalOpen,
  decideFormElement,
}) => (
  <>
    {Object.entries(groupedStaticAttributes).map(([classification, inputs]) => {
      const regularInputs = inputs.filter(
        (i) => i.html_tag !== LOCATION_SETTINGS_TAG,
      );
      const locationSettingsInputs = inputs.filter(
        (i) => i.html_tag === LOCATION_SETTINGS_TAG,
      );

      return (
        <React.Fragment key={`Fragment-${classification}`}>
          {regularInputs.length > 0 && (
            <SectionRow key={`SectionRow-${classification}`}>
              <Grid.Column span="2">
                <CommandIconAndTitle
                  title={classification}
                  onClick={() => handleSchemaDetailsModalOpen(classification)}
                />
              </Grid.Column>
              <Grid.Column key={`Column-${classification}`}>
                <ClassificationInputs
                  inputs={{ ...regularInputs }}
                  classification={classification}
                  decideFormElement={decideFormElement}
                />
              </Grid.Column>
            </SectionRow>
          )}
          {locationSettingsInputs.map((input) => (
            <React.Fragment key={`LS-Fragment-${input.name}`}>
              <LabelOnlyRow>
                <Grid.Column span="2">
                  <CommandIconAndTitle
                    title={t`Location Settings`}
                    onClick={() => {}}
                  />
                </Grid.Column>
              </LabelOnlyRow>
              <ContinuedSectionRow>
                <Grid.Column span="2" />
                <Grid.Column span="10">{decideFormElement(input)}</Grid.Column>
              </ContinuedSectionRow>
            </React.Fragment>
          ))}
        </React.Fragment>
      );
    })}
  </>
);

GroupedStaticAttributesSection.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  groupedStaticAttributes: PropTypes.object.isRequired,
  handleSchemaDetailsModalOpen: PropTypes.func.isRequired,
  decideFormElement: PropTypes.func.isRequired,
};
export default GroupedStaticAttributesSection;
